/**
 * Checks the current instance's token at 50-second intervals and dispatches an action to renew it whenever its
 * expiration UNIX timestamp comes within ten minutes of the current UNIX time.
 */
import store from '@/store/store'

export default {
  install (Vue) {
    Vue.startAuthVerifier = () => {
      let authTimer = setInterval(() => {
        let requested = store.getters.renewalRequested
        const exp = parseFloat(store.getters.getActiveInstance.exp)
        const tenMinFromNow = (new Date().getTime() / 1000) + 600
        if (tenMinFromNow >= parseFloat(exp) && !requested) {
          store.dispatch('requestNewToken')
        }
      }, 50000)
      store.dispatch('setAuthVerificationTimer', authTimer)
    }

    Vue.stopAuthVerifier = () => {
      const timer = store.getters.getAuthVerificationTimer
      clearInterval(timer)
      store.dispatch('setAuthVerificationTimer', null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/authverification/auth_verifier.js